import { resourceEduCode } from '~/api/oneBoxV3/oneBoxV3.type';

export type TLatestNewsAttachment = {
  id: string;
  fileName: string;
  url: string;
  sizeBytes: number;
  mime: string;
  sort: number;
  /** 選檔後尚未上傳；儲存時會先呼叫 uploadAttachment */
  pendingFile?: File | null;
};

export type TLatestNewsItem = {
  id: string;
  title: string;
  /** 列表摘要／預覽 */
  summary: string;
  contentHtml: string;
  /** 分類標籤（多選；對應後台分類節點名稱） */
  tags: string[];
  /** 上架日期（YYYY-MM-DD，列表顯示用） */
  publishedAt: string;
  /** 後端 publishAt（含時間）；有值時優先於 publishedAt 做可見性與排序 */
  publishAt?: string;
  /** 下架時間（ISO 字串，datetime-local；空則無自動下架） */
  takeDownAt: string | null;
  /** 學程（可多選；送 API 時為陣列） */
  eduCodes: resourceEduCode[];
  subjects: string[];
  schoolYears: string[];
  grades: string[];
  /** 封面圖 URL（與上傳擇一或並存，前台優先可另定） */
  coverImageUrl: string;
  /** 封面媒體 ID（後台／CDN 識別用） */
  coverMediaId: string;
  mediaType: 'image' | 'video' | null;
  mediaDataUrl: string | null;
  /** YouTube 網址或影片 ID（單一） */
  youtubeUrl: string;
  /** 附件（最多 8，單篇合計 ≤15MB 由後端驗證；此處記錄結構） */
  attachments: TLatestNewsAttachment[];
  seoMetaTitle: string;
  seoMetaDescription: string;
  seoOgImageUrl: string;
  /** 草稿／已發布 */
  status: 'draft' | 'published';
  /** 後端停用（若有） */
  disabled?: boolean;
  /** 同分鐘排序輔助 */
  sortAssist: number | null;
  createdAt: number;
  updatedAt: number;
  createdBy: string;
  updatedBy: string;
};

/**
 * 資料來自 `POST /v1/articles/public/getArticles` 時使用：後端已篩「已上架」，
 * 前端不再用 publishAt 做「未到上架日」過濾（避免與後端時區／規則重複而誤藏文章）。
 * 仍排除草稿、停用；若 `enforceTakeDown` 為 true，另排除已過下架時間者。
 */
export const isArticleListedOnPublicFeed = (
  a: TLatestNewsItem,
  now = Date.now(),
  options?: { enforceTakeDown?: boolean },
) => {
  const enforceTakeDown = options?.enforceTakeDown ?? true;
  if (a.disabled) return false;
  if (a.status === 'draft') return false;
  if (enforceTakeDown && a.takeDownAt) {
    const end = Date.parse(a.takeDownAt);
    if (Number.isFinite(end) && now > end) return false;
  }
  return true;
};
